export const QUESTIONS_R = [
//R01
    {
  q: '②老視や白内障は【水晶体】の疾患である．',
  s: 'R01', ch: '解剖',
},
{
  q: '③99%が水分でできている眼球の構造物は【硝子体】である．',
  s: 'R01', ch: '解剖',
},
{
  q: '④眼球の構造物のうち，光の通り道となる【角膜】，【水晶体】，【硝子体】には血管がない．',
  s: 'R01', ch: '解剖',
},
{
  q: '⑤角膜の厚さは約【0.5】mmで，【屈折】力に最も関与する眼球の構造物である．上皮側は【涙】，内皮側は【房水】から栄養される．内皮は【透明性】の維持に関与し，【再生】能をもたない．角膜には血管はないが神経はあり，角膜反射がみられる．',
  s: 'R01', ch: '解剖',
},
{
  q: '⑥ぶどう膜は【虹彩】(光の量を調節)，【毛様体】(房水を産生)，【脈絡膜】(網膜を栄養)から成り，血管に富む組織である．三大ぶどう膜炎は【サルコイドーシス】，【Behçet病】，【Vogt-小柳-原田病】である．脈絡膜由来の新生血管を生じる疾患に【加齢黄斑変性】症がある．',
  s: 'R01', ch: '解剖',
},
{
  q: '⑦網膜は【10】層構造である．網膜の一番奥が【色素上皮】層，次に【視細胞】層があり，この間で【網膜剥離】が起こりやすい．',
  s: 'R01', ch: '解剖',
},
{
  q: '⑧視力・色覚に関与する視細胞は【錐体】細胞で，【黄斑】(【中心】窩)に多く存在する．',
  s: 'R01', ch: '解剖',
},
{
  q: '⑨暗所視・光覚に関与する視細胞は【杆体】細胞で，網膜周辺部に多く分布する．ビタミン【A】不足で夜盲を呈する．',
  s: 'R01', ch: '解剖',
},
{
  q: '⑩視神経が集まる乳頭部は【鼻】側にあり，これに対応する【Mariotte盲点】は視野の【耳】側にある．',
  s: 'R01', ch: '解剖',
},
{
  q: '⑪房水の流れ',
  s: 'R01', ch: '解剖',
  type: 'indent',
  rows: [
    { level: 0, text: '・【毛様体】で産生 → 【後】房 → 【瞳孔】 → 【前】房 → 【隅角】 → 【線維柱帯】 → 【Schlemm管】' },
    { level: 0, text: '・一部の房水は毛様体の筋組織の間から強膜外へ排泄(【ぶどう膜強膜】流出路)' },
  ]
},
{
  q: '⑫閉塞隅角緑内障では眼圧が上昇し，【散】瞳する(より隅角が狭くなり，より眼圧を高める)．',
  s: 'R01', ch: '解剖',
},
{
  q: '⑬網膜を栄養する動脈血は【内頸】動脈 → 【眼】動脈 → 網膜中心動脈へと流れる．',
  s: 'R01', ch: '解剖',
},
{
  q: '⑭眼球運動に関与する筋・支配神経',
  s: 'R01', ch: '解剖',
  type: 'indent',
  rows: [
    { level: 0, text: '・【内直】筋・【下斜】筋・【上直】筋・【下直】筋：【動眼神経(Ⅲ)】支配' },
    { level: 0, text: '・【上斜】筋：【滑車神経(Ⅳ)】支配' },
    { level: 0, text: '・【外直】筋：【外転神経(Ⅵ)】支配' },
  ]
},
{
  q: '⑮眼輪筋は【顔面】神経支配で，【閉】眼に関わる筋である．上眼瞼挙筋は【動眼】神経支配，眼板筋は【交感】神経支配で，これらは【開】眼に関わる筋である．',
  s: 'R01', ch: '解剖',
},
{
  q: '⑯眼瞼下垂の原因に【動眼】神経麻痺，【Horner】症候群，【重症筋無力】症，加齢，【コンタクトレンズ】長年装用がある．',
  s: 'R01', ch: '解剖',
},
{
  q: '⑰眼窩を構成する骨',
  s: 'R01', ch: '解剖',
  type: 'indent',
  rows: [
    { level: 0, text: '・【篩】骨，【蝶形】骨，【口蓋】骨，【上顎】骨，【頬】骨，【前頭】骨，【涙】骨' },
  ]
},
{
  q: '⑱上眼窩裂を通る脳神経は【Ⅲ】，【Ⅳ】，【Ⅵ】，【Ⅴ1】である．',
  s: 'R01', ch: '解剖',
},
{
  q: '⑲涙の流れ',
  s: 'R01', ch: '解剖',
  type: 'indent',
  rows: [
    { level: 0, text: '・涙腺(【上外】側) → 涙点(【鼻】側) → 【涙小】管 → 涙囊 → 【鼻涙】管 → 【下】鼻道' },
  ]
},
//R02
{
  q: '①視交叉の障害でみられる視野障害は【両耳側半盲】である．',
  s: 'R02', ch: '視野',
},
{
  q: '②上1/4半盲がみられる場合は【側頭】葉の視放線障害，下1/4半盲がみられる場合は【頭頂】葉での視放線障害である．',
  s: 'R02', ch: '視野',
},
{
  q: '③後頭葉の障害で生じる視野障害では，【黄斑回避】を伴う同名半盲がみられる．',
  s: 'R02', ch: '視野',
},
{
  q: '④外側膝状体は対光反射の経路に含まれ【ず】，一方でE-W核は対光反射の経路に含まれ【る】．',
  s: 'R02', ch: '視野',
},
{
  q: '⑤対光反射の入力路は【視】神経，出力路は【動眼】神経である．',
  s: 'R02', ch: '視野',
},
{
  q: '⑥右目に光を照射して左眼が縮瞳した．これは【左】眼の【間】接対光反射である．',
  s: 'R02', ch: '視野',
},
{
  q: '⑦眼底所見で乳頭部は【鼻】側にあり，視野の【外】側にMariotte盲点がある．',
  s: 'R02', ch: '視野',
},
{
  q: '②調節力(D)＝(1/【近点距離】(m))－(1/【遠点距離】(m))　近点25cm，遠点50cmの調節力は【2.0】Dとなる．',
  s: 'R02', ch: '視力',
},
{
  q: '①眼球構造のうち，屈折作用があるのは【角膜】と【水晶体】である．毛様体筋の作用で水晶体の厚みが変わり屈折力が変化することを【調節】という．',
  s: 'R02', ch: '屈折・調節',
},
{
  q: '②毛様体筋は副交感神経(動眼神経)支配で，毛様体筋【収縮】によりZinn小帯が【弛緩】し，水晶体が【厚】くなることで焦点が【前】方に移動し，近くのものを見る．',
  s: 'R02', ch: '屈折・調節',
},
{
  q: '①瞳孔【散大】筋が収縮すると散瞳し，隅角は【狭】くなる．副交感神経が優位にはたらくと瞳孔【括約】筋が収縮し【縮】瞳する．',
  s: 'R02', ch: '散瞳と縮瞳',
},
{
  q: '②散瞳・縮瞳する要因',
  s: 'R02', ch: '散瞳と縮瞳',
  type: 'indent',
  rows: [
    { level: 0, text: '・散瞳：【暗】所，精神的興奮(【交感】神経が優位な状態)，【緑内障】発作，【アドレナリン】作動薬(瞳孔散大筋収縮)，【抗コリン】薬(瞳孔括約筋弛緩)' },
    { level: 0, text: '・縮瞳：【明】所，【近】見時，【対光】反射，【コリン作動】薬' },
  ]
},
{
  q: '③散瞳薬には【アトロピン】，【トロピカミド】などが，縮瞳薬には【ピロカルピン】などがある．',
  s: 'R02', ch: '散瞳と縮瞳',
},
{
  q: '④眼底検査や虹彩毛様体炎の治療に用いるのは【散】瞳薬，緑内障の治療に用いるのは【縮】瞳薬である．',
  s: 'R02', ch: '散瞳と縮瞳',
},
{
  q: '①両目を同時に内転させる運動を【輻湊】といい，主に【近】見時に起こる．両目を同時に外転させる運動を【開散】といい，主に【遠】見時に起こる．',
  s: 'R02', ch: '輻湊と開散・近見反射',
},
{
  q: '②近くのものを見ようとするときに【縮】瞳・【調節】・【輻輳】の3つが同時に起こることを近見反射という．近見反射で水晶体は【厚く】なり，毛様体筋は【収縮】し，Zinn小帯は【弛緩】する．',
  s: 'R02', ch: '輻湊と開散・近見反射',
},

// R03 屈折・調節異常
{
  q: '①近視・遠視・乱視は【屈折】異常，老視は【調節】異常である．',
  s: 'R03', ch: '屈折・調節異常',
},
{
  q: '②近視では焦点が網膜より【前】に結ぶため遠くが見えにくい．原因として屈折力が【強】い，眼軸が【長】いことが挙げられる．',
  s: 'R03', ch: '屈折・調節異常',
},
{
  q: '③近視の矯正には【凹】レンズ，遠視の矯正には【凸】レンズを用いる．',
  s: 'R03', ch: '屈折・調節異常',
},
{
  q: '④角膜の歪みにより焦点が1点に定まらない状態を【乱視】という．矯正には【円柱】レンズなどを用いる．',
  s: 'R03', ch: '屈折・調節異常',
},
{
  q: '⑤加齢とともに水晶体が硬くなることで調節力が減退し，近くが見えにくくなった状態を【老視】という．矯正に【凸】レンズを用いる．',
  s: 'R03', ch: '屈折・調節異常',
},
{
  q: '⑦3歳の女児．視力は右0.3(0.5×＋3.0D)，左0.4(0.8×＋3.5D)．調節麻痺薬点眼後の矯正視力は右(0.5×＋6.0D)，左(0.9×＋6.0D)．→ 適切な治療は右【＋6.0】D，左【＋6.0】Dの眼鏡処方．',
  s: 'R03', ch: '屈折・調節異常',
},

// R03 弱視・斜視
{
  q: '①視力が最も発達する【乳幼児】期に，視力に関する神経の発達が障害されると【弱視】になる．原因は【遠】視，先天性【白内障】，【斜】視，【不同】視など．',
  s: 'R03', ch: '弱視・斜視',
},
{
  q: '②斜視の種類',
  s: 'R03', ch: '弱視・斜視',
  type: 'indent',
  rows: [
    {level:0, text:'両眼でものを注視する際，左右の眼の向きがずれている状態を【斜視】という．'},
    { level: 0, text: '・調節性内斜視：【遠】視の小児で水晶体を厚くするため過度の調節・輻輳が生じ眼が【内】転する斜視．発症は1～3歳頃が多い．弱視の予防に【矯正眼鏡】で治療を行う' },
    { level: 0, text: '・【間欠性外斜視】：遠見時，ぼんやりしているとき，疲労時にのみ外斜視が出現．遮閉試験で診断する' },
  ]
},

// R03 暗点・狭窄
{
  q: '①Mariotte盲点拡大の原因として【うっ血乳頭】や【緑内障】初期がある．',
  s: 'R03', ch: '暗点・狭窄',
},
{
  q: '②加齢黄斑変性症，中心性漿液性脈絡網膜症，【網膜中心動脈】閉塞症，視神経炎では【中心】暗点がみられる．',
  s: 'R03', ch: '暗点・狭窄',
},
{
  q: '③開放隅角緑内障による視野異常に【傍中心】暗点，【弓状】暗点，【鼻側階段】がある．',
  s: 'R03', ch: '暗点・狭窄',
},
{
  q: '④視神経炎では中心暗点とMariotte盲点がつながる【ラケット】状(【盲中心】)暗点がみられる．',
  s: 'R03', ch: '暗点・狭窄',
},
{
  q: '⑤輪状暗点をきたす疾患は【網膜色素変性】症で，【桿体】細胞の変性による疾患である．輪状暗点が進行すると【求心】性【視野狭窄】をきたす．',
  s: 'R03', ch: '暗点・狭窄',
},
{
  q: '⑥らせん状視野，管状視野は【心因性】疾患で認めうる．',
  s: 'R03', ch: '暗点・狭窄',
},

// R03 うっ血乳頭と視神経炎
{
  q: '①うっ血乳頭とは【頭蓋内圧亢進】により視神経乳頭部が浮腫状に腫脹した状態である．視野検査で【Mariotte盲点】の【拡大】を認める．自覚症状に【頭痛】，【悪心】があり，視力障害はきたしにくい．',
  s: 'R03', ch: 'うっ血乳頭と視神経炎',
},
{
  q: '②視神経炎には乳頭炎と球後視神経炎があり，乳頭炎では眼底検査で乳頭【浮腫】を認める．視神経炎の症状には初期からみられる【視力低下】，【眼球運動時】痛があり，視野検査で【中心暗点】，【ラケット状暗点】を呈する．視神経炎の主な原因に【多発性硬化症】，【エタンブトール】，【メチルアルコール】がある．',
  s: 'R03', ch: 'うっ血乳頭と視神経炎',
},

// R03 見え方の異常
{
  q: '①光を異常にまぶしく感じる状態を【羞明】といい，散乱・調節障害(【白内障】，散瞳)や敏感性亢進(角膜疾患，【虹彩毛様体】炎)が主な原因となる．',
  s: 'R03', ch: '見え方の異常',
},
{
  q: '②光が当たってないのに光を感じる状態を【光視症】といい，網膜への物理的刺激(【網膜剝離】，網膜裂孔)が主な原因となる．',
  s: 'R03', ch: '見え方の異常',
},
{
  q: '③黒い影が浮遊して見える状態を【飛蚊症】といい，【硝子体】出血，【網膜剥離】，【ぶどう膜炎】が主な原因となる．',
  s: 'R03', ch: '見え方の異常',
},
{
  q: '④物が歪んで見える状態を【変視症】といい，網膜(特に黄斑)の病変(網膜剥離，【中心性漿液性脈絡網膜】症，【加齢黄斑変性】症など)が主な原因となる．',
  s: 'R03', ch: '見え方の異常',
},
{
  q: '⑤電灯など灯りの周りに虹の輪がかかって見える状態を【虹視症】といい，角膜の浮腫や不整で生じる．鑑別疾患に【緑内障発作】，眼精疲労がある．',
  s: 'R03', ch: '見え方の異常',
},

// R03 その他の症候
{
  q: '①角膜縁から放射状に紫紅色となる眼の充血を【毛様】充血という．原因疾患に角膜実質炎，【虹彩毛様体】炎，【閉塞隅角緑内障】，強膜炎がある．',
  s: 'R03', ch: 'その他の症候',
},
{
  q: '②周辺部が鮮紅色となる眼の充血を【結膜】充血という．原因疾患に結膜炎，表層角膜炎がある．',
  s: 'R03', ch: 'その他の症候',
},
{
  q: '③眼瞼下垂の原因に【加齢】，【コンタクトレンズ】，脳【動脈瘤】，【重症筋無力】症，【Horner】症候群などがある．',
  s: 'R03', ch: 'その他の症候',
},
{
  q: '④眼球突出の原因に【甲状腺機能亢進】症，【内頸動脈海綿静脈洞瘻】，【多発血管炎性肉芽腫】症などがある．',
  s: 'R03', ch: 'その他の症候',
},
// R04 検査
{
  q: '①正常の眼底所見では，網膜の色は茶褐色(日本人)，中心窩の色は暗赤色，動脈径と静脈径の比は【2】:【3】である．',
  s: 'R04', ch: '検査',
},
{
  q: '②正常の視神経乳頭はやや縦長の楕円，淡紅黄白色，境界鮮明である．乳頭拡大・境界不鮮明では【乳頭浮腫】を，視神経乳頭陥凹では【緑内障】を考える．',
  s: 'R04', ch: '検査',
},
{
  q: '③眼底を立体的に観察できる検眼鏡は【倒】像鏡で，観察範囲が広く上下左右は反転する．',
  s: 'R04', ch: '検査',
},
{
  q: '④造影剤を静注して撮影し，眼底部の血管を通過するところを撮影する眼科検査を【蛍光眼底造影】検査という．網膜の血管，新生血管，浮腫を観察しやすい．',
  s: 'R04', ch: '検査',
},
{
  q: '⑤近赤外線を眼底に照射し，その反射強度が組織や深さによって異なることを利用して画像化する眼科検査を【光干渉断層】法(【OCT】)という．',
  s: 'R04', ch: '検査',
},
{
  q: '⑥細隙灯顕微鏡検査では前眼部(角膜，【前房】，【虹彩】，【水晶体】)を観察できる．細隙灯顕微鏡検査の前には【散瞳】薬を用いる．',
  s: 'R04', ch: '検査',
},
{
  q: '⑦隅角・硝子体・網膜を観察するためには細隙灯顕微鏡と【Goldmann三面鏡】を組み合わせて使う．',
  s: 'R04', ch: '検査',
},
{
  q: '⑧Goldmann定量視野計では【動的量的】視野検査を行う．',
  s: 'R04', ch: '検査',
},
{
  q: '⑨徹照法では透光体の【角膜】，【水晶体】，【硝子体】を観察できる．',
  s: 'R04', ch: '検査',
},
{
  q: '⑩視力検査の指標は外径7.5mm，太さ1.5mm，切れ目1.5mmの【Landolt環】を基本とし，この切れ目が【5】mの距離から識別できれば視力1.0と評価する．',
  s: 'R04', ch: '検査',
},
{
  q: '⑪Hess赤緑検査は【眼球運動】検査である．',
  s: 'R04', ch: '検査',
},
{
  q: '⑫仮性同色表は【色覚検査】のスクリーニングに用いる．',
  s: 'R04', ch: '検査',
},
{
  q: '⑬アムスラーチャートは【変視】症の検査として有効である．',
  s: 'R04', ch: '検査',
},
{
  q: '⑭眼底を観察できない重度の白内障術前検査で【網膜電図】を用いることがある．',
  s: 'R04', ch: '検査',
},
{
  q: '⑮視覚誘発電位が有用な疾患に【多発性硬化症】，【視神経】疾患がある．',
  s: 'R04', ch: '検査',
},
{
  q: '⑯網膜電図で律動小波のみが消失していた場合，【糖尿病網膜症】を考える．網膜電図の平坦化で疑う疾患は【網膜色素変性】症である．',
  s: 'R04', ch: '検査',
},
{
  q: '⑰角膜内皮の状態をみる検査は【スペキュラーマイクロスコピー】である．白内障手術前などに【水疱性角膜】症のリスク評価として用いる．',
  s: 'R04', ch: '検査',
},

// R04 様々な眼底所見
{
  q: '①緑内障の眼底検査では【乳頭陥凹】がみられ，C/D比が【大き】くなる．',
  s: 'R04', ch: '様々な眼底所見',
},
{
  q: '②網膜中心動脈閉塞症の眼底検査では【cherry red spot】が観察される．',
  s: 'R04', ch: '様々な眼底所見',
},
{
  q: '③網膜中心静脈閉塞症の眼底検査では【火炎】状眼底，【軟性】白斑が観察される．',
  s: 'R04', ch: '様々な眼底所見',
},
{
  q: '④Vogt-小柳-原田病の眼底検査では初期に【多発】する【滲出】性【網膜剥離】，回復期では【夕焼け状】眼底がみられる．',
  s: 'R04', ch: '様々な眼底所見',
},
{
  q: '⑤サルコイドーシスの前眼部病変では【豚脂様角膜後面沈着物】が特徴的．',
  s: 'R04', ch: '様々な眼底所見',
},
{
  q: '⑥Behçet病の前眼部病変では【前房蓄膿】がみられる．',
  s: 'R04', ch: '様々な眼底所見',
},
{
  q: '⑦加齢黄斑変性症の眼底検査では【黄斑】部の【出血】，【新生血管】，【網膜剥離】，浮腫が観察される．',
  s: 'R04', ch: '様々な眼底所見',
},
{
  q: '⑧中心性漿液性脈絡網膜症では眼底検査で【黄斑】部に【単発】の【漿液】性【網膜剥離】がみられる．',
  s: 'R04', ch: '様々な眼底所見',
},
{
  q: '⑨糖尿病性網膜症では眼底検査で【硬性白斑】(フィブリン等の沈着)，【軟性白斑】(虚血の所見)，【毛細血管】瘤，【新生血管】などがみられる．',
  s: 'R04', ch: '様々な眼底所見',
},
{
  q: '⑩高血圧性網膜症では眼底検査で【動脈】狭小化，【動静脈交叉】現象が観察される．',
  s: 'R04', ch: '様々な眼底所見',
},
{
  q: '⑪網膜色素変性症では【周辺】部に【骨小体】様の沈着物がみられ，網膜血管や視神経乳頭の【萎縮】がみられる．',
  s: 'R04', ch: '様々な眼底所見',
},

// R05 角膜疾患
{
  q: '①角膜の上皮障害による主な病変は【点状表層角膜】炎・角膜【びらん】，実質障害による主な病変は角膜【潰瘍】，内皮障害による主な病変は角膜【浮腫】である．',
  s: 'R05', ch: '角膜疾患',
},
{
  q: '②角膜上皮障害の主な原因は【ドライアイ】，眼瞼【内反】，【電気性】眼炎，ウイルス(【アデノ】，【ヘルペス】)，細菌(【緑膿】菌，【ブドウ球】菌，肺炎球菌)である．',
  s: 'R05', ch: '角膜疾患',
},
{
  q: '③角膜の【内皮】は透明性の維持に関与しており，角膜の中で再生不能な構造物である．角膜内皮障害がみられる主な疾患に【緑内】障，ぶどう膜炎，内眼手術後の【水疱性角膜】症がある．',
  s: 'R05', ch: '角膜疾患',
},
{
  q: '④コンタクトレンズ装用の合併症',
  s: 'R05', ch: '角膜疾患',
  type: 'indent',
  rows: [
    { level: 0, text: '・感染症：原因病原体に【アカントアメーバ】，【緑膿菌】がある' },
    { level: 0, text: '・酸素不足：角膜【新生血管】，【水疱性角膜症】を呈する' },
    { level: 0, text: '・アレルギー：【巨大乳頭結膜炎】(Ⅰ型アレルギー)' },
  ]
},
{
  q: '⑤単純ヘルペスウイルスの感染により単純ヘルペス角膜炎を生じる．症状は【自発】痛，角膜知覚【低下】，流涙，視力低下，羞明など．上皮型では【点】状・【線】状→【樹枝】状→【地図】状角膜炎と発展する．実質型では【円板状】角膜炎もしくは【壊死性】角膜炎を呈し，ウイルス感染後の抗原抗体反応が原因のため病変からウイルスが分離【されない】．上皮型の治療は【アシクロビル】眼軟膏，実質型の治療は【ステロイド】点眼＋【アシクロビル】眼軟膏．',
  s: 'R05', ch: '角膜疾患',
},
{
  q: '⑥アカントアメーバは【原虫】の一つ．【コンタクトレンズ】の不適切な保存・使用は激しい【眼痛】を伴うアカントアメーバ角膜炎の誘因となる．',
  s: 'R05', ch: '角膜疾患',
},
{
  q: '⑦ドライアイ(乾性角結膜炎)は涙液の量・質の異常により角膜障害を呈するもので，原因は【VDT】作業，【Sjögren】症候群，【顔面神経】麻痺による【兎】眼など．有用な検査に【フルオレセイン】染色，【ローズベンガル】染色，【Schirmer】試験(【涙液分泌】試験)がある．治療は【人工涙液】やヒアルロン酸製剤の点眼．',
  s: 'R05', ch: '角膜疾患',
},
{
  q: '⑧電気性眼炎は溶接やスキー，海などで【紫外線】を長時間曝露した【6】～【24】時間後に起こる表層角膜炎で，眼痛，流涙，羞明，結膜充血をきたす．',
  s: 'R05', ch: '角膜疾患',
},
{
  q: '⑨水疱性角膜症は角膜【内皮】細胞減少により不可逆的な角膜浮腫を生じたもので，主症状は視力低下，【眼痛】．原因に内眼術後，外傷，【コンタクトレンズ】長期装用がある．有用な検査はスペキュラーマイクロスコピー，治療は【角膜移植】．',
  s: 'R05', ch: '角膜疾患',
},
{
  q: '⑩Wilson病は血清中のセルロプラスミン低下を本態とする【常】染色体【潜】性遺伝疾患で，角膜のDescemet膜に銅が沈着した【Kayser-Fleischer】輪を認める．視力低下を伴【わない】．治療は【D-ペニシラミン】投与．',
  s: 'R05', ch: '角膜疾患',
},
{
  q: '⑪遺伝性に両眼性・進行性の角膜混濁を生じる疾患を【角膜ジストロフィー】といい，進行すると視力低下を認める．治療は【角膜移植】．',
  s: 'R05', ch: '角膜疾患',
},
{
  q: '⑫角膜の実質が菲薄化し，中央が円錐状に隆起する原因不明の疾患を【円錐角膜】という．【アトピー性皮膚】炎や【Down】症候群に合併することが多い．不正乱視となるため，矯正に【ハードコンタクトレンズ】を用いる．',
  s: 'R05', ch: '角膜疾患',
},

// R05 結膜疾患
{
  q: '①ウイルス性結膜炎では【漿液】性眼脂，細菌性結膜炎では【膿】性眼脂がみられる．',
  s: 'R05', ch: '結膜疾患',
},
{
  q: '②咽頭結膜熱(プール熱)はアデノウイルス【3】型による感染症であり，潜伏期間は約1週間で，症状は3～4日持続する．咽頭炎・結膜炎，【発熱】を認め，【夏】季・【小児】に好発する．出席停止基準は「主要症状消退後【2日】を経過するまで」．',
  s: 'R05', ch: '結膜疾患',
},
{
  q: '③流行性角結膜炎(はやり目)はアデノウイルス【8】型による感染症で，潜伏期間は7～10日，症状は【2】～【3週間】持続する．強い結膜充血や【偽膜形成】(重症例)を認めるが，発熱は【ない】．三徴は【角膜上皮下混濁】，【急性濾胞性結膜炎】，【耳前リンパ節腫脹】．',
  s: 'R05', ch: '結膜疾患',
},
{
  q: '④急性出血性結膜炎は【エンテロウイルス70型】と【コクサッキーウイルスA群】が原因となる．潜伏期間は約【1】日，症状は約1週間持続する．症状は【結膜下出血】を呈し，耳前リンパ節腫脹は軽度．',
  s: 'R05', ch: '結膜疾患',
},
{
  q: '⑤細菌性結膜炎の主な起因菌には黄色ブドウ球菌，【クラミジア】，【淋菌】がある．トラコーマ，封入体結膜炎の原因は【クラミジア】である．',
  s: 'R05', ch: '結膜疾患',
},
{
  q: '⑥アレルギー性結膜炎は花粉やハウスダストによる【Ⅰ】型アレルギーで，【掻痒】を伴う．治療は【抗アレルギー】薬点眼．',
  s: 'R05', ch: '結膜疾患',
},
{
  q: '⑦花粉やハウスダストなどが原因で激しい掻痒・石垣状【乳頭増殖】をきたすアレルギー性結膜疾患を【春季カタル】という．【Ⅰ】型および【Ⅳ】型アレルギーが関与する．治療は【抗アレルギー】薬，【ステロイド】，【免疫抑制】薬の点眼．',
  s: 'R05', ch: '結膜疾患',
},
{
  q: '⑧機械的刺激により春季カタルより小さな乳頭増殖を伴うⅠ型アレルギー性結膜疾患を【巨大乳頭結膜炎】といい，原因は【コンタクトレンズ】の不衛生などである．治療はコンタクトレンズ中止，抗アレルギー薬点眼．',
  s: 'R05', ch: '結膜疾患',
},
{
  q: '⑨細菌に対するⅣ型アレルギーによる角結膜炎を【フリクテン角結膜】炎といい，角膜の小結節や血管侵入がみられる．視力低下をきたすこともあり，【抗菌薬】と【ステロイド】の点眼の併用が著効する．',
  s: 'R05', ch: '結膜疾患',
},
{
  q: '⑩結膜下の血管が破れ血がもれている状態を結膜下出血といい，結膜を塗りつぶしたように鮮血色が広がる．原因は外傷や【急性出血性結膜炎】など．眼痛はきたさないことが多く，経過観察にて1～2週間で吸収される．',
  s: 'R05', ch: '結膜疾患',
},
{
  q: '⑪翼状片は【結膜】組織が【鼻】側から増殖し角膜に侵入する疾患である．原因は【加齢】や外的刺激(埃，紫外線)など．治療は【外科的切除】で，再発も多い．',
  s: 'R05', ch: '結膜疾患',
},

// R05 強膜疾患
{
  q: '①強膜全体が青色または灰青色に見える状態を【青色強膜】という．視機能に異常はないが，【骨形成不全】症や【難聴】などを合併することが多い．',
  s: 'R05', ch: '強膜疾患',
},
{
  q: '②上強膜炎・強膜炎は【関節リウマチ】やSLEに合併しやすい．眼痛，羞明，流涙などがみられる．強膜炎は上強膜炎より重症で，【虹彩毛様体】炎や角膜炎を合併しやすい．',
  s: 'R05', ch: '強膜疾患',
},

// R05 眼瞼・涙器疾患
{
  q: '①涙囊炎と麦粒腫の原因は【黄色ブドウ球菌】などの細菌感染症である．疼痛を伴う．治療は【抗菌薬】投与，【切開排膿】．',
  s: 'R05', ch: '眼瞼・涙器疾患',
},
{
  q: '②霰粒腫はMeibom腺の慢性炎症性【肉芽腫】であり，疼痛は伴わない．治療は【ステロイド】点眼もしくは眼軟膏，摘出．鑑別疾患として【脂腺癌】が重要である．',
  s: 'R05', ch: '眼瞼・涙器疾患',
},
// R06
// R06 ぶどう膜炎
{
  q: '①三大ぶどう膜炎のうち，虹彩毛様体炎(前部ぶどう膜炎)を起こしやすい疾患は【サルコイドーシス】，【Behçet病】，網脈絡膜炎(後部ぶどう膜炎)を起こしやすい疾患は【Vogt-小柳-原田病】である．他に【トキソプラズマ】症，潰瘍性大腸炎，眼部帯状【ヘルペス】，強直性脊椎炎などもぶどう膜炎をきたす．',
  s: 'R06', ch: 'ぶどう膜炎',
},
{
  q: '②虹彩毛様体炎では毛様充血，流涙，【眼痛】，霧視，【羞明】などがみられ，水晶体に炎症が波及すると【白内障】，虹彩前癒着をきたすと【緑内障】，虹彩後癒着をきたすと【瞳孔】不整が生じる．網脈絡膜炎では飛蚊症，【霧視】，視力低下などがみられる．',
  s: 'R06', ch: 'ぶどう膜炎',
},
{
  q: '③ぶどう膜炎ではフレアセルフォトメトリーにて【房水フレア】(蛋白濃度上昇)，【房水セル】(浮遊細胞)がみられる．',
  s: 'R06', ch: 'ぶどう膜炎',
},
{
  q: '④ぶどう膜炎の治療は【ステロイド】(点眼 or 全身投与)，虹彩毛様体炎には続発緑内障の予防に【散瞳】薬を用いる．',
  s: 'R06', ch: 'ぶどう膜炎',
},
{
  q: '⑤サルコイドーシスは非乾酪性肉芽腫を生じる疾患で，病変で特徴的なものに【豚脂様角膜後面沈着物】，【虹彩結節】，【雪玉】状硝子体混濁がある．',
  s: 'R06', ch: 'ぶどう膜炎',
},
{
  q: '⑥Behçet病は【好中球】活性化による血管炎で，前眼部病変の特徴に【前房蓄膿】がある．ステロイド・アトロピン点眼の他，治療に用いる薬剤として【コルヒチン】，【インフリキシマブ】(抗【TNF-α】抗体)，シクロスポリンがある．',
  s: 'R06', ch: 'ぶどう膜炎',
},
{
  q: '⑦Vogt-小柳-原田病は全身の【メラノサイト】に対する【自己免疫】疾患である．【東洋】人に多く，HLA-【DR4】陽性例が多い．感冒様症状(前駆期)の後，白斑・白髪，【視力低下】，【感音難聴】・【耳鳴り】を起こす．蛍光眼底造影検査やOCTにて【多発】する【滲出】性【網膜剥離】がみられ，髄液検査で【リンパ】球主体の【細胞増多】を認める．回復期(数ヵ月後)には眼底所見で【夕焼け】状眼底がみられる．治療はステロイド【全身】投与，アトロピン点眼を行う．',
  s: 'R06', ch: 'ぶどう膜炎',
},
{
  q: '⑧片眼の穿孔性外傷や硝子体術後，3～4ヵ月後に対側の眼にもぶどう膜炎を生じることがあり，これを【交感性眼炎】という．【メラノサイト】への自己免疫反応が原因とされ，【Vogt-小柳-原田病】の眼底所見に類似する．',
  s: 'R06', ch: 'ぶどう膜炎',
},

// R07 網膜動脈・静脈閉塞症
{
  q: '①網膜動脈閉塞症は【心房細動】，遊離塞栓が原因となる．突発性・無痛性の高度【視力低下】がみられる．網膜中心動脈閉塞症では【中心】暗点がみられ，眼底所見で【cherry red spot】を認める．網膜動脈分枝閉塞症では閉塞血管に一致した部位の限局性網膜浮腫を認める．1時間以内に治療を開始しないと【失明】に至るおそれがある．治療に【眼球マッサージ】，高圧酸素療法，【亜硝酸アミル】，ウロキナーゼ，前房穿刺がある．',
  s: 'R07', ch: '網膜動脈閉塞症と網膜静脈閉塞症',
},
{
  q: '②網膜静脈閉塞症は動脈硬化が原因となり，【高血圧】，【脂質異常】症，【糖尿】病がリスクとなる．網膜中心静脈閉塞症では眼底所見で【火炎】状網膜出血，【軟】性白斑を認める．網膜静脈分枝閉塞症では扇子状に広がる出血層がみられ，【上耳】側に好発する．視力低下や視野欠損のほか，合併症として【虹彩ルベオーシス】(→【血管新生緑内障】)をきたす．',
  s: 'R07', ch: '網膜動脈閉塞症と網膜静脈閉塞症',
},
{
  q: '③虹彩ルベオーシスとは網膜血管床の虚血により，虹彩・隅角に【新生血管】を生じるものである．難治性の【血管新生緑内障】の原因となる．主な原因疾患は【網膜中心静脈】閉塞症，増殖【糖尿病網膜症】，【内頸動脈】狭窄症など．治療に【網膜光凝固】と【抗VEGF薬硝子体内注射】がある．',
  s: 'R07', ch: '網膜動脈閉塞症と網膜静脈閉塞症',
},

// R07 糖尿病網膜症
{
  q: '①糖尿病網膜症の眼底所見と治療',
  s: 'R07', ch: '糖尿病網膜症',
  type: 'grouped',
  categories: [
    {
      label: '単純',
      groups: [{ label: '', rows: [
        { term: '眼底所見', desc: '網膜【浮腫】，【毛細血管】瘤，網膜【点状出血】，【硬】性白斑' },
        { term: '治療', desc: '血糖コントロール' },
      ]}]
    },
    {
      label: '増殖前',
      groups: [{ label: '', rows: [
        { term: '眼底所見', desc: '【軟】性白斑，【無血管】野' },
        { term: '治療', desc: '【網膜光凝固】，急激な【血糖降下】や運動は避ける' },
      ]}]
    },
    {
      label: '増殖',
      groups: [{ label: '', rows: [
        { term: '眼底所見', desc: '【新生血管】，【硝子体】出血，【牽引】性【網膜剥離】，【虹彩ルベオーシス】' },
        { term: '治療', desc: '【網膜光凝固】，硝子体出血に対し【硝子体手術】' },
      ]}]
    },
  ]
},
{
  q: '③黄斑浮腫は糖尿病網膜症のどの段階でも発症しうる．変視症・視力低下の症状が現れる．治療の第一選択は【抗VEGF薬硝子体内注射】．',
  s: 'R07', ch: '糖尿病網膜症',
},
{
  q: '④糖尿病性網膜症は【若】年者の方が進行しやすく，発症【初】期から網膜電図で【律動小波】の減弱がみられる．',
  s: 'R07', ch: '糖尿病網膜症',
},

// R07 高血圧性網膜症
{
  q: '①高血圧性網膜症の眼底所見',
  s: 'R07', ch: '高血圧性網膜症',
  type: 'indent',
  rows: [
    { level: 0, text: '・高血圧性変化：動脈【狭細】化，出血，網膜【浮腫】，硬性白斑，軟性白斑，乳頭【浮腫】' },
    { level: 0, text: '・動脈硬化性変化：動脈壁反射亢進，【交叉現象】，銅線動脈，銀線動脈' },
    { level: 0, text: '・※ 高血圧性網膜症では毛細血管瘤は認めない(糖尿病網膜症の所見)．' },
  ]
},
{
  q: '②軟性白斑は網膜の局所的な【虚血】でみられる．軟性白斑を認める疾患には増殖前/増殖糖尿病網膜症，高血圧性網膜症，【網膜静脈閉塞】症，【SLE】などの膠原病がある．',
  s: 'R07', ch: '高血圧性網膜症',
},

// R07 中心性漿液性脈絡網膜症と加齢黄斑変性症
{
  q: '①黄斑部に病変をきたす疾患では【中心】暗点や【変】視症がみられる．',
  s: 'R07', ch: '中心性漿液性脈絡網膜症と加齢黄斑変性症',
},
{
  q: '②中心性漿液性脈絡網膜症は【中】年【男】性に好発し，【変】視症，【小】視症を呈する．また眼軸が短くなることで【遠】視傾向となる．眼底検査では【黄斑】部に【単】発の【漿液性網膜剥離】を認め，蛍光眼底造影では色素の漏出点が確認される．多くは自然治癒するが，漏出点を【網膜光凝固】することで治癒期間が短縮する．ストレス，【ステロイド】はリスクファクターである．',
  s: 'R07', ch: '中心性漿液性脈絡網膜症と加齢黄斑変性症',
},
{
  q: '③加齢黄斑変性症は加齢により生じる原因不明の黄斑変性で，眼底検査で黄斑部の出血，脈絡膜新生血管が，OCTで網膜浮腫，網膜剥離が認められる．新生血管や出血は伴わない．治療の第一選択は抗VEGF薬硝子体内注射で，その他に網膜光凝固(中心窩には行わない)，光線力学療法，生活指導(抗酸化物質の摂取，禁煙)を行う．',
  s: 'R07', ch: '中心性漿液性脈絡網膜症と加齢黄斑変性症',
},
{
  q: '④加齢黄斑変性の前駆病変として軟性ドルーゼンが重要で，これは網膜色素上皮の代謝機能が低下することで老廃物が沈着した所見である．',
  s: 'R07', ch: '中心性漿液性脈絡網膜症と加齢黄斑変性症',
},
{
  q: '⑤加齢や外傷などにより中心窩に孔があく疾患を黄斑円孔，後部硝子体剥離の際に硝子体の膜が黄斑部に残存する疾患を黄斑上膜(網膜前膜)という．いずれも中心暗点，変視症，視力低下がみられる．治療は硝子体手術．',
  s: 'R07', ch: '中心性漿液性脈絡網膜症と加齢黄斑変性症',
},

// R07 網膜剥離
{
  q: '①網膜の一番奥に【色素上皮】層，次に【視細胞】層があり，この間で網膜剥離が起こりやすい．特に網膜の【上耳】側に好発する．',
  s: 'R07', ch: '網膜剥離',
},
{
  q: '②網膜剝離の分類と主な原因',
  s: 'R07', ch: '網膜剥離',
  type: 'indent',
  rows: [
    { level: 0, text: '・裂孔原性網膜剥離：【外傷】，【アトピー性皮膚炎】，高度【近視】，加齢' },
    { level: 0, text: '・牽引性網膜剥離：【糖尿病網膜症】(硝子体出血)' },
    { level: 0, text: '・漿液性網膜剥離：【中心性漿液性脈絡網膜】症，【Vogt-小柳-原田】病，【加齢黄斑変性】症' },
  ]
},
{
  q: '③網膜剥離の症状は【光視】症，【飛蚊】症，視野欠損で，【黄斑】部に剥離が及ぶと急激な視力低下をきたす．眼圧は【低下】する傾向にある．',
  s: 'R07', ch: '網膜剥離',
},
{
  q: '④診断に【眼底検査】，【ERG】，眼球超音波検査，OCTが有用．',
  s: 'R07', ch: '網膜剥離',
},
{
  q: '⑤網膜裂孔のみで剥離がない場合，治療は【網膜光凝固】である．網膜剥離状態では治療に【強膜内陥】術(バックルなどを入れて圧迫し裂孔の閉鎖を促す方法)，硝子体手術がある．',
  s: 'R07', ch: '網膜剥離',
},

// R07 網膜色素変性症
{
  q: '①網膜色素変性症は遺伝性に【杆体】細胞が変性する両側性の疾患であり，【幼児】期～【青年】期から発症する．',
  s: 'R07', ch: '網膜色素変性症',
},
{
  q: '②網膜色素変性症の症状は【夜盲】で発症し，数十年経過すると視力低下，失明をきたす．',
  s: 'R07', ch: '網膜色素変性症',
},
{
  q: '③網膜色素変性症は視野検査にて【輪状】暗点をきたし，【求心性】視野狭窄に至る．眼底所見では【骨小体様色素沈着】，網膜血管の【狭細】化，【視神経乳頭】の萎縮がみられる．網膜電図では波形が【平坦】化する．根本的な治療法はなく，進行を遅らせる可能性がある治療や合併症に対する治療を行う．',
  s: 'R07', ch: '網膜色素変性症',
},

// R07 その他の網膜疾患
{
  q: '①0～5歳の乳幼児期に発症する眼内悪性腫瘍を【網膜芽細胞腫】という．30～40%は【常】染色体【顕】性遺伝で，【Rb1】遺伝子異常が関与する．【白】色瞳孔で発見され，CTやMRI，エコーなどで石灰化を認める．治療は早期発見例かつ腫瘍が小さければ保存的治療が第一選択，進行例では【眼球摘出】など．',
  s: 'R07', ch: 'その他の網膜疾患',
},
{
  q: '②未熟児網膜症は網膜血管が未熟な児に【高濃度酸素】を持続供給することで，新生血管の増殖や【網膜剥離】を生じるものである．進行例では白色瞳孔を認める．治療は無血管帯への網膜光凝固．',
  s: 'R07', ch: 'その他の網膜疾患',
},

// R07 網膜疾患の治療まとめ
{
  q: '①網膜光凝固',
  s: 'R07', ch: '網膜疾患の治療',
  type: 'grouped',
  categories: [
    {
      label: '【網膜裂孔】の予防',
      groups: [{ label: '', rows: [
        { term: '対象疾患', desc: '網膜裂孔' },
      ]}]
    },
    {
      label: '【新生血管】の抑制',
      groups: [{ label: '', rows: [
        { term: '対象疾患', desc: '糖尿病網膜症(増殖前以降)，網膜静脈閉塞症，未熟児網膜症，加齢黄斑変性症，血管新生緑内障' },
      ]}]
    },
    {
      label: '滲出物の吸収促進',
      groups: [{ label: '', rows: [
        { term: '対象疾患', desc: '【中心性漿液性脈絡網膜】症(治癒期間の短縮)' },
      ]}]
    },
  ]
},
{
  q: '②抗VEGF薬硝子体内注射の適応疾患',
  s: 'R07', ch: '網膜疾患の治療',
  type: 'indent',
  rows: [
    { level: 0, text: '・【加齢黄斑変性】症' },
    { level: 0, text: '・【糖尿病網膜】症における黄斑浮腫' },
    { level: 0, text: '・【網膜静脈閉塞】症' },
    { level: 0, text: '・【血管新生】緑内障' },
    { level: 0, text: '・病的【近視】による脈絡膜新生血管' },
  ]
},
{
  q: '③硝子体手術の適応に【硝子体出血】，硝子体混濁，【黄斑円孔】，【黄斑上膜】，網膜剥離などがある．術後合併症に網膜剥離や白内障などがある．',
  s: 'R07', ch: '網膜疾患の治療',
},
{
  q: '④治療法の比較(❶〜❸は抗VEGF薬/硝子体手術/網膜光凝固のいずれか)　❶：【網膜光凝固】　❷：【抗VEGF薬】　❸：【硝子体手術】',
  s: 'R07', ch: '網膜疾患の治療',
  type: 'grouped',
  categories: [
    {
      label: '中心性漿液性脈絡網膜症',
      groups: [{ label: '', rows: [
        { term: '治療', desc: '❶：○' },
      ]}]
    },
    {
      label: '加齢黄斑変性',
      groups: [{ label: '', rows: [
        { term: '治療', desc: '❶：○　❷：○　❸：○' },
      ]}]
    },
    {
      label: '黄斑円孔，黄斑上膜',
      groups: [{ label: '', rows: [
        { term: '治療', desc: '❸：○' },
      ]}]
    },
    {
      label: '糖尿病網膜症，網膜静脈閉塞症',
      groups: [{ label: '', rows: [
        { term: '治療', desc: '❶：○　❷：○　❸：○' },
      ]}]
    },
    {
      label: '網膜剥離',
      groups: [{ label: '', rows: [
        { term: '治療', desc: '❶：○　❸：○' },
      ]}]
    },
  ]
},
// R08 白内障
{
  q: '①白内障とは水晶体の混濁により視力障害をきたした病態をいう．原因には【加齢】(最多)，【アトピー性皮膚炎】(若年の原因として多い)，【ステロイド】使用(進行が速い)，【糖尿病】，筋強直性ジストロフィー，【ぶどう膜炎】，【副甲状腺機能低下】症，眼外傷，【風疹】(胎内感染)，Down症候群などがある．',
  s: 'R08', ch: '白内障',
},
{
  q: '②白内障の症状には【左右】差があることが多く，【羞明】，【霧視】，視力低下などを認める．検査所見として【細隙灯顕微鏡】検査，【徹照】法で水晶体混濁を認める．',
  s: 'R08', ch: '白内障',
},
{
  q: '③白内障の点眼薬に【ピレノキシン】がある(進行を遅らせるが，根治は望めない)．',
  s: 'R08', ch: '白内障',
},
{
  q: '④白内障は日常生活に支障があれば手術適応となり，術式は【超音波乳化吸引術】・眼内レンズ挿入である．術前に眼内レンズの度数決定のため【角膜曲率半径】と【眼軸長】を測定する．高度白内障に対しては術前検査に【網膜電図】を追加する．',
  s: 'R08', ch: '白内障',
},
{
  q: '⑤白内障の術後合併症',
  s: 'R08', ch: '白内障',
  type: 'indent',
  rows: [
    { level: 0, text: '・術後【眼内炎】(感染症)：治療は抗菌薬，硝子体手術' },
    { level: 0, text: '・【前囊収縮】，後発【白内障】：治療はYAGレーザー' },
    { level: 0, text: '・【水疱性角膜症】：治療は角膜移植．リスク予測のため術前検査に【スペキュラーマイクロスコピー】を行う' },
  ]
},
{
  q: '⑥眼内レンズは定期的な入れ替えが【不】要である．超音波乳化吸引術にて水晶体を除去すると，正視の場合には【遠】視の状態になる．',
  s: 'R08', ch: '白内障',
},

// R08 その他の水晶体疾患
{
  q: '①水晶体亜脱臼の原因となる疾患に【Marfan】症候群やホモシスチン尿症がある．',
  s: 'R08', ch: 'その他の水晶体疾患',
},
{
  q: '②水晶体表面を覆っていた瞳孔膜が完全に吸収されず残ってしまった先天異常を【瞳孔膜遺残】といい，頻度の高い先天異常である．間隙から光が入るため視力障害をきたさないことが多い．',
  s: 'R08', ch: 'その他の水晶体疾患',
},

// R09 緑内障総論
{
  q: '①緑内障では眼圧上昇や視神経の脆弱性などにより視神経が障害される．わが国の失明の原因の第【1】位である．有病率は40歳以上の約【5】%で，加齢に伴い【増加】する．',
  s: 'R09', ch: '緑内障',
},
{
  q: '②緑内障の分類',
  s: 'R09', ch: '緑内障',
  type: 'indent',
  rows: [
    { level: 0, text: '・原発緑内障：他の原因疾患がない緑内障' },
    { level: 1, text: '・原発【開放隅角】緑内障：線維柱帯以降の房水流出抵抗増大による緑内障' },
    { level: 2, text: '・【正常眼圧】緑内障：眼圧が正常範囲の原発開放隅角緑内障' },
    { level: 1, text: '・原発【閉塞隅角】緑内障：急性緑内障発作を起こす' },
    { level: 0, text: '・【続発】緑内障：他の疾患により二次的に発症する緑内障' },
    { level: 0, text: '・わが国で最も多い緑内障の病型は【正常眼圧緑内障】である．' },
  ]
},
{
  q: '③続発緑内障の原因に【ステロイド】使用，【ぶどう膜】炎(→ 虹彩癒着)，【血管新生】緑内障(虹彩ルベオーシス)，水晶体起因性緑内障(【白内障】による水晶体膨化)，悪性緑内障(濾過手術後)などがある．',
  s: 'R09', ch: '緑内障',
},
{
  q: '④先天性の隅角形成異常による緑内障を小児緑内障という．原因疾患に【Sturge-Weber】症候群などがあり，眼圧上昇で角膜が伸展し【牛】眼を呈することがある．',
  s: 'R09', ch: '緑内障',
},

// R09 原発閉塞隅角緑内障
{
  q: '⑤隅角の閉塞により眼圧が上昇する．急性緑内障発作は短時間で失明しうる．症状に激しい眼痛(【頭痛】と訴えることも多い)，【嘔吐】，角膜浮腫による【霧視】・【虹輪視】，視力低下がある．',
  s: 'R09', ch: '原発閉塞隅角緑内障',
},
{
  q: '⑥主な他覚所見は角膜【浮腫】，【浅】前房(【狭】隅角)，【結膜】・【毛様】充血，【散】瞳である．',
  s: 'R09', ch: '原発閉塞隅角緑内障',
},
{
  q: '⑦まずコリン作動薬(【ピロカルピン】)の点眼，浸透圧利尿薬(【マンニトール】，【グリセロール】)や炭酸脱水酵素阻害薬(アセタゾラミド)の点滴静注などで眼圧を下降させる．',
  s: 'R09', ch: '原発閉塞隅角緑内障',
},
{
  q: '⑧十分な角膜の透明性が得られた後に【レーザー虹彩切開術】やレーザー隅角形成術を行う．',
  s: 'R09', ch: '原発閉塞隅角緑内障',
},

// R09 原発開放隅角緑内障
{
  q: '⑨原発開放隅角緑内障は，隅角は閉塞していないが，【線維柱帯】以降での房水流出抵抗増大が原因で起こる．初期は自覚症状に乏しくときに【眼精疲労】などの不定愁訴を呈し，進行すると【視野狭窄】を認める．',
  s: 'R09', ch: '原発開放隅角緑内障',
},
{
  q: '⑩原発開放隅角緑内障では眼圧はあまり高くないが，日内変動が大きい．眼底検査にて視神経【乳頭陥凹】(【C/D比】拡大)，網膜【神経線維層欠損】(NFLD)がみられる．NFLDと一致する視野狭窄を認める．',
  s: 'R09', ch: '原発開放隅角緑内障',
},
{
  q: '⑪原発開放隅角緑内障は，視野検査にて【傍中心】暗点，【鼻側階段】，【弓状】暗点(【Bjerrum】暗点)を認め，鼻側穿破 → 【求心性】視野狭窄へと進行する．',
  s: 'R09', ch: '原発開放隅角緑内障',
},
{
  q: '⑫原発開放隅角緑内障の薬物療法',
  s: 'R09', ch: '原発開放隅角緑内障',
  type: 'indent',
  rows: [
    { level: 0, text: '・房水流出促進薬：【PG】製剤(第一選択)，【α1遮断】薬，【Rhoキナーゼ阻害】薬' },
    { level: 0, text: '・房水産生抑制薬：【β遮断】薬(第二選択)，【α2刺激】薬，【炭酸脱水酵素阻害】薬' },
  ]
},
{
  q: '⑬薬物療法で効果不十分な場合，【レーザー線維柱帯形成】術や線維柱帯切除術(濾過手術)などの外科的治療を行う．',
  s: 'R09', ch: '原発開放隅角緑内障',
},

// R10
{
  q: '①交感性眼炎は眼外傷や内眼手術の3～4週間後以降に【対】側の眼にも発症する重篤なぶどう膜炎である．外傷眼でぶどう膜，メラノサイトへの【自己免疫】反応が形成されることで発症する．症状や眼底所見はVogt-小柳-原田病に類似する．治療は【ステロイド】静注，【アトロピン】点眼．',
  s: 'R10', ch: 'その他の疾患',
},
{
  q: '②眼窩部の鈍的外傷などで眼窩内圧上昇により起こる眼窩底陥没骨折を吹き抜け骨折という．眼窩【下】壁に多い．骨折部位に【下直】筋が陥没することで眼球の【上転】障害や【複視】がみられるほか，眼球【陥凹】，頬部【感覚鈍麻】などをきたす．',
  s: 'R10', ch: 'その他の疾患',
},
{
  q: '③酸やアルカリによる眼の化学的損傷では大量の【水道水】や【生理食塩水】で15分以上洗い流し，眼科医を必ず受診する．中和目的に酸やアルカリで洗浄してはならない．',
  s: 'R10', ch: 'その他の疾患',
},
{
  q: '④上眼窩裂症候群：障害される脳神経は【Ⅲ】，【Ⅳ】，【Ⅴ1】，【Ⅵ】で，症状に【散瞳】，【眼瞼下垂】，【眼】痛，【角膜知覚】低下，【眼球運動】障害がある．障害部位が眼窩の奥まで及ぶと上眼窩裂症候群の症状に加えて【視力低下】(脳神経【Ⅱ】の障害)をきたし，これを眼窩先端部症候群という．',
  s: 'R10', ch: 'その他の疾患',
},
]